export default __webpack_public_path__ + "static/media/3dprinting.657815df.png";